<template>
    <div class="table-list landlord-mgt-list">
        <modal class="del-landlord" :display="modalState.delLandlordModal" @modalStatus="closeModal()" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除帳號</h1>
            <div class="content">
                確定要刪除“{{delLandlordData.landlordName}}”帳號嗎？確定後將直接刪除此房東
            </div>
            <div class="btn-group">
                <button class="default-button" @click="delLandlord()">確認</button>
                <button class="border-button" @click="closeModal()">取消</button>
            </div>
        </modal>

        <div class="mask"></div>
        <div class="table-list-title">
            <span class="name">房東姓名</span>
            <span class="count">房源數量</span>
            <span class="phone">聯絡電話</span>
            <span class="bill-time">結帳時間</span>
            <span class="agent">開發人員</span>
            <span class="bonus">貢獻金額</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && landlordList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="landlordList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="name">{{list.name}}</span>
                    <span class="count">{{list.houseCount}}</span>
                    <span class="phone">{{list.mobilePhone}}</span>
                    <span v-if="list.reconcileDayOfMonth" class="bill-time">每月 {{list.reconcileDayOfMonth}} 號</span>
                    <span v-else class="bill-time">-</span>
                    <span class="agent">{{list.developer}}</span>
                    <span class="bonus">{{toCurrency(list.contributionAmount)}}</span>
                    <span class="action">
                        <dot-drop-menu>
                            <ul>
                                <router-link :to="{ name: 'bizViewLandlord', query: {cId: list.id}}">
                                    <li>查看屋主</li>
                                </router-link>
                                <router-link :to="{name: 'bizHouseMgtDefault', query: {filterWord: list.name}}">
                                    <li>查看所有房源</li>
                                </router-link>
                                <router-link :to="{ name: 'bizEditLandlord', query: {cId: list.id}}"
                                    v-if="bizAuth.editLandlord.hasRight">
                                    <li>編輯房東</li>
                                </router-link>
                                <li v-if="bizAuth.deleteLandlord.hasRight" @click="delLandlordData.arrears = list.arrears, delLandlordData.landlordId = list.id, delLandlordData.landlordName = list.name, openModal(list)">刪除房東</li>
                            </ul>
                        </dot-drop-menu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            delLandlordData: {
                landlordId: null,
                landlordName: null,
                arrears: false
            },
            modalState: {
                delLandlordModal: false
            },
            isLoading: true
        }
    },
    props: {
        
    },
    watch: {
        
    },
    created() {
        this.getLandlordList();
    },
    methods: {
        getLandlordList: function () {
            this.$store.dispatch('getBizLandlordList')
            .then(()=>{
                this.isLoading = false
            })
        },
        setFilterDefault: function () {
            console.log('setDefault')
            this.$store.dispatch('setlBizLandlordFilterWord', null)
            // TODO
        },
        // 刪除帳號
        delLandlord: function () {
            this.$analyticsBiz.logEvent('刪除帳號', { screen_name: '帳號列表'})
            this.$store.dispatch('delBizLandlord', this.delLandlordData.landlordId)
            .then(res => {
                if(res.data.status = "SUCCESS"){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '成功刪除房東',type: 'error'})
                    this.modalState.delLandlordModal = false
                    this.getLandlordList()
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                console.log(err)
            })
        },
        openModal: function (item) {
            if(item.houseCount){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '有房源的房東不可刪除',type: 'error', closeBtn: true})
            }else if(item.arrears){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '當房源有欠款時，不得刪除房東',type: 'error', closeBtn: true})
            }else{
                this.modalState.delLandlordModal = true
            }
        },
        closeModal: function () {
            this.modalState.delLandlordModal = false
        },
    },
    computed: {
        filterByWord: function () {
            return this.landlordList.filter((item) => {
                if( this.filterWord ){
                    if( item.name.includes(this.filterWord) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            landlordList: 'GET_BIZ_LANDLORD_LIST',
            filterWord: 'GET_BIZ_LANDLORD_FILTER_WORD',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        DotDropMenu,
        Modal,
        tableLoading
    }
}
</script>
<style lang="scss">
    // test TODO start
    .test-profile-pic{
        width: 24px;
        height: 24px;
        margin-right: 8px;
        background-color: #d8d8d8;
        border-radius: 50%;
    }
    // test TODO end
    .table-list-body ul li{
        line-height: 1.5;
    }
    .table-list.landlord-mgt-list{
        margin-bottom: 150px;
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 76px;
            margin-right: 96px;
            display: flex;
            align-items: center;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
        }
        .table-list-title .count,
        .table-list-body ul li .count{
            width: 60px;
            margin-right: 106px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .phone,
        .table-list-body ul li .phone{
            width: 79px;
            margin-right: 116px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .bill-time,
        .table-list-body ul li .bill-time{
            width: 67px;
            margin-right: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .agent,
        .table-list-body ul li .agent{
            width: 66px;
            margin-right: 107px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .table-list-title .bonus,
        .table-list-body ul li .bonus{
            width: 61px;
            margin-right: 108px;
            text-align: right;
            // overflow: hidden;
            // text-overflow: ellipsis;
        }
        .table-list-title .action,
        .table-list-body ul li .action{
            width: 28px;
        }
        #modal.del-landlord{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px){
        // .table-list.landlord-mgt-list{
            
        // }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/landlordMgt/landlordMgtList.vue